import { appDynamicLink } from '../../libs/constants'
import BottomButtonArea from '../common/BottomButtonArea'
import ErrorScreenTopArea from '../common/ErrorScreenTopArea'
import NavBar from '../common/NavBar'
import { ga4Event } from '../libs/ga4'
import useGA4Pageview from '../libs/hooks/useGA4Pageview'

export default function ErrorAifiOwnerOnlyScreen() {
  useGA4Pageview('slash_login_notall_notowner')
  return (
    <>
      <NavBar />
      <ErrorScreenTopArea
        title="未符合購買資格"
        content={
          <p className="babu-text-paragraph text-text600">
            此商品僅供擁有智能雲的用戶購買，系統已自動登出。若欲購買商品，即刻購買智能雲後再試一次！
          </p>
        }
      />
      <BottomButtonArea
        variant="solid"
        onClick={() => {
          ga4Event('slash_login_notall_notowner_open')
          setTimeout(() => {
            window.location.href = appDynamicLink
          }, 10)
        }}>
        開啟 aifian
      </BottomButtonArea>
    </>
  )
}
